/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ArchivedInputs */

const en_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

const es_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivado`)
};

const fr_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivée`)
};

const de_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert`)
};

const ja_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ済み`)
};

const zh_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已归档`)
};

const ar_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مؤرشف`)
};

const id_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diarsipkan`)
};

const it_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviato`)
};

const ru_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В архиве`)
};

const pt_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivado`)
};

const ko_archived = /** @type {(inputs: ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관됨`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {ArchivedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const archived = /** @type {((inputs?: ArchivedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ArchivedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_archived(inputs)
	if (locale === "es") return es_archived(inputs)
	if (locale === "fr") return fr_archived(inputs)
	if (locale === "de") return de_archived(inputs)
	if (locale === "ja") return ja_archived(inputs)
	if (locale === "zh") return zh_archived(inputs)
	if (locale === "ar") return ar_archived(inputs)
	if (locale === "id") return id_archived(inputs)
	if (locale === "it") return it_archived(inputs)
	if (locale === "ru") return ru_archived(inputs)
	if (locale === "pt") return pt_archived(inputs)
	return ko_archived(inputs)
});